/**
 * Register Quill table-better module so it is available in all Quill editors.
 * Must be imported before the app bootstraps (e.g. from main.ts).
 */
import Quill from 'quill';
import QuillTableBetter from 'quill-table-better';

Quill.register(
  {
    'modules/table-better': QuillTableBetter
  },
  true
);
